import Spinner from 'components/Spinner/Spinner';
import PropTypes from 'prop-types';
import React, { Suspense } from 'react';

function AsyncComponent({ children }) {
  return <Suspense fallback={<Spinner />}>{children}</Suspense>;
}

AsyncComponent.propTypes = {
  children: PropTypes.node.isRequired,
};
export default AsyncComponent;
